import { FormDialog } from "components/dialogs/Dialogs";
import { intl } from "LocaleWrapper";
import { FormGroup, Textarea } from "@cofano/cck";
import { usePermission } from "components/utils/Permission";
import { Controller, useForm } from "react-hook-form";
import FormField from "components/cck/FormField";
import { zodResolver } from "@hookform/resolvers/zod";
import {
	EntityHistoryRemarkDialogInput,
	EntityHistoryRemarkDialogOutput,
	EntityHistoryRemarkDialogSchema,
} from "components/entityHistory/utils/entityHistory.schema";

const EntityHistoryRemarkDialog = ({ promise }: {
	promise: {
		resolve: (remark: string | null) => void;
		reject: () => void;
	} | null;
}) => {

	const { isAdmin } = usePermission();

	const { control, handleSubmit } = useForm<EntityHistoryRemarkDialogInput, unknown, EntityHistoryRemarkDialogOutput>({
		defaultValues: {
			remark: "",
		},
		resolver: zodResolver(EntityHistoryRemarkDialogSchema(!isAdmin)),
		shouldUnregister: true,
	});

	return (
		<FormDialog
			open={promise !== null}
			onClose={() => promise?.reject()}
			title={intl.formatMessage({ id: "REVISION_REMARK_DIALOG_TITLE" })}
			form="saveButtonRemarkForm"
		>
			<form
				id="saveButtonRemarkForm"
				onSubmit={handleSubmit(data => {
					promise?.resolve(data.remark.trim() || null);
				})}
			>
				<FormGroup label={intl.formatMessage({ id: "REVISION_REMARK" })} required={!isAdmin}>
					<Controller
						name="remark"
						control={control}
						render={({ field, formState: { errors } }) => (
							<FormField name={field.name} errors={errors}>
								<Textarea {...field} rows={6} />
							</FormField>
						)}
					/>
				</FormGroup>
			</form>
		</FormDialog>
	);
};

export default EntityHistoryRemarkDialog;
